import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { PurchaseOrdMaster } from '../../TitleList';
import { fetchPOData } from '../../../Store/PHPSlice/Purchase/PoNo';
import { selectPOData } from '../../Selectors/Master/ItemSelectors';

const PurchaseOrderTable = () => {
    const dispatch = useDispatch();
    const POlist = useSelector(selectPOData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchPOData());
    }, [dispatch]);

    if (!POlist) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(POlist?.data) ? POlist?.data?.map((item, index) => (
        {
            srno: item.ID,
            poNo: item.poNo,
            dt: item.dt,
            partyNm: item.partyNm,
            mainvendorNm:item.mainvendorNm,
            subvendorNm:item.subvendorNm,
            firmNm: item.firmNm,
            shiftTo: item.shiftTo,
            tot_mtr: item.tot_mtr,
            amt: item.amt,
            finalAmt: item.finalAmt,
            cloth: item.cloth,
            deldt: item.deldt,
            rate: item.rate,
            mtr: item.mtr,
            inwMtr: item.inwMtr,
            balMtr: item.balMtr,
            igst: item.igst,
            igstAmt: item.igstAmt,
            cgst: item.cgst,
            cgstAmt: item.cgstAmt,
            sgst: item.sgst,
            sgstAmt: item.sgstAmt,
            insts: item.insts,
            soId: item.soId,
            sono: item.sono,
            ordtype: item.ordtype,
            serialNumber: index + 1
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.partyNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.poNo?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={PurchaseOrdMaster} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Purchase Order Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />



                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'info', label: 'Info' },
                                                { id: 'ordtype', label: 'Order Type' },
                                                { id: 'poNo', label: 'PONo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'sono', label: 'SO No.' },
                                                { id: 'partyNm', label: 'Purchase Party' },
                                                {id:'mainvendorNm',label:'Main Vendor'},
                                                {id:'subvendorNm',label:'Sub Vendor'},
                                                { id: 'firmNm', label: 'Firm' },
                                                // { id: 'cloth', label: 'Cloth' },
                                                // { id: 'shiftTo', label: 'Shift To' },
                                                // { id: 'tot_mtr', label: 'Qty' },
                                                // { id: 'amt', label: 'Amount' },
                                                { id: 'finalAmt', label: 'Taxable Amount' },
                                                // { id: 'cloth', label: 'Cloth' },
                                                { id: 'deldt', label: 'Delivery Date' },
                                                // { id: 'rate', label: 'Rate' },
                                                // { id: 'mtr', label: 'Issue Mtr' },
                                                // { id: 'inwMtr', label: 'Inw. Mtr' },
                                                // { id: 'balMtr', label: 'Bal. Mtr' },
                                                // { id: 'igst', label: 'IGST' },
                                                // { id: 'igstAmt', label: 'IGSTAmt' },
                                                // { id: 'cgst', label: 'CGST' },
                                                // { id: 'cgstAmt', label: 'CGSTAmt' },
                                                // { id: 'sgst', label: 'SGST' },
                                                // { id: 'sgstAmt', label: 'SGSTAmt' },
                                                { id: '', label: 'Status' },
                                                { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                poNo={row.poNo}
                                                dt={row.dt}
                                                partyNm={row.partyNm}
                                                mainvendorNm={row.mainvendorNm}
                                                subvendorNm={row.subvendorNm}
                                                firmNm={row.firmNm}
                                                shiftTo={row.shiftTo}
                                                tot_mtr={row.tot_mtr}
                                                amt={row.amt}
                                                finalAmt={row.finalAmt}
                                                cloth={row.cloth}
                                                deldt={row.deldt}
                                                rate={row.rate}
                                                mtr={row.mtr}
                                                inwMtr={row.inwMtr}
                                                balMtr={row.balMtr}
                                                igst={row.igst}
                                                igstAmt={row.igstAmt}
                                                cgst={row.cgst}
                                                cgstAmt={row.cgstAmt}
                                                sgst={row.sgst}
                                                sgstAmt={row.sgstAmt}
                                                insts={row.insts}
                                                soId={row.soId}
                                                sono={row.sono}
                                                ordtype={row.ordtype}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default PurchaseOrderTable;
